import { Division } from '../models';

export function transformDivisionNames(selectedDivisionIds: number[], availableDivisions: Division[]): string {
  return availableDivisions
    .filter(name => selectedDivisionIds.includes(name.id))
    .map(division => division.name)
    .join(', ');
}
